
import { defineComponent } from "vue";
import { ICategoriesModel } from "@/interfaces/modules";
// Servicio análogo al patrón usado en tu ejemplo:
import CategoriesService from "@/api/Configuration/CategoriesService";
import store from "@/store";

export default defineComponent({
  name: "CategoriesContent",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ICategoriesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Type", label: "Tipo", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ICategoriesModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: ICategoriesModel) =>
            [
              item.Code,
              item.Description,
              item.Type,
              item.CreatedByName,
              item.ModifiedByName,
            ]
              .filter(Boolean)
              .some((v) => String(v).toLowerCase().includes(q))
          )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await CategoriesService.GetCategories();
      this.table.loading = false;
    },
    async edit(data: ICategoriesModel) {
      // En tu API, usualmente basta con el Id
      this.form.record = await CategoriesService.GetCategoryById({ Id: data.Id }as ICategoriesModel);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as ICategoriesModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await CategoriesService.PostCategory(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
